import { cssColorValue, cssSpacing, rootStyle, semanticColors } from "../../styles/index.mjs";
import styled from "../../styled-components.mjs";
export var Label = styled.span.withConfig({
  displayName: "Label",
  componentId: "sc-fd2j9b-0"
})(["", ";color:", ";padding-inline-end:", ";"], rootStyle(), cssColorValue(semanticColors.textSubdued), cssSpacing('tighter', '12px'));